module.exports = __webpack_public_path__ + "img/ico-cs.af0deba5.svg";